import DesignTokens from '@tableau/design-tokens';
import { cssRule } from 'typestyle';

import { applyColor }from '~src/style/ColorService';

cssRule('.tb-dialog-create-task-schedule .tb-dialog-create-task-label', {
    marginBottom: '6px',
});

cssRule('.tb-dialog-create-task-schedule .tb-sss-pane', {
    width: '500px',
});

cssRule('.tb-dialog-create-task-type', {
    marginTop: '12px',
});

cssRule('.tb-dialog-create-task-type .tb-dialog-create-task-label', {
    marginTop: '3px',
});

cssRule('.tb-dialog-create-task-type .tb-dialog-create-task-type-option', {
    margin: '3px',
    display: 'block',
});

cssRule('.tb-dialog-create-task-type .tb-dialog-create-task-type-option input', {
    margin: '0 6px 0 0',
});

cssRule('.tb-dialog-create-task-type .tb-dialog-create-task-type-option .tb-dialog-create-task-type-label', {
    display: 'inline-block',
    verticalAlign: 'top',
});

cssRule('.tb-create-extract-refresh-mode-selector', {
    borderBottom: '1px solid ' + applyColor(DesignTokens.color.elevation.border.default.subtle, '#E6E6E6'),
});

cssRule('.tb-create-extract-refresh-mode-selector-button', {
    display: 'inline-block',
    verticalAlign: 'top',
    textDecoration: 'none',
    cursor: 'pointer',
    marginRight: '18px',
});

cssRule('.tb-create-extract-refresh-mode-selector-button >.tb-label', {
    display: 'inline-block',
    verticalAlign: 'baseline',
    height: '27px',
    lineHeight: '27px',
    fontSize: '15px',
    fontWeight: 'normal',
    color: applyColor(DesignTokens.color.font.default.secondary, '#666'),
    borderBottom: '3px solid transparent',
});

cssRule('.tb-create-extract-refresh-mode-selector-button:hover, .tb-create-extract-refresh-mode-selector-button:focus', {
    textDecoration: 'none',
});

cssRule('.tb-create-extract-refresh-mode-selector-button:hover >.tb-label, .tb-create-extract-refresh-mode-selector-button:focus >.tb-label', {
    color: applyColor(DesignTokens.color.font.default.default, '#333'),
});

cssRule('.tb-create-extract-refresh-mode-selector-button.tb-selected >.tb-label, .tb-create-extract-refresh-mode-selector-button.tb-selected:hover >.tb-label', {
    color: applyColor(DesignTokens.color.font.default.default, '#333'),
    fontWeight: 'bold',
    borderBottom: '3px solid ' + applyColor(DesignTokens.color.link.inline.default.hover, '#2a5775'),
});

